export default __webpack_public_path__ + "static/media/mobile-prakerja.b3c3a7a3.png";